import { Skeleton, Stack } from '@inflearn/ds-react';
import { useLang } from '@inflearn/i18n-tools';
import { range } from 'lodash-es';

const SKELETON_COUNT_BY_LANG = {
  ko: 4,
  international: 2,
} as const;

export const NotificationSkeleton = () => {
  const { isKo } = useLang();

  return (
    <Stack spacing={20}>
      <Stack spacing={4}>
        <Skeleton w={80} h={30} radius="md" />
        <Skeleton w="100%" h={20} radius="md" />
      </Stack>

      <Stack spacing={20}>
        {range(SKELETON_COUNT_BY_LANG[isKo ? 'ko' : 'international']).map((line) => (
          <Skeleton key={line} w="100%" h={80} radius="md" />
        ))}
      </Stack>
    </Stack>
  );
};
